import React from 'react';
import Axios from '../axios';
import moment from 'moment';
export const handleNav = (list) => {
  // list = []
  if (list && list.length) {
    return list.map((item, index) => (
      <tr key={`nav-${index}`}>
        <td>{item.UPDATEDATE}</td>
        <td>人民币</td>
        <td colSpan="4">{item.NAV}</td>
      </tr>
    ))
  } else {
    return (
      <tr key={`nav`}>
        <td>-</td>
        <td>人民币</td>
        <td colSpan="4">-</td>
      </tr>
    )
  }
}
export const getFundEndDate = async (fundCode) => {
  try {
    const data = await Axios.ajaxAESETF({
      url: '/aresoft-api/api/fundinfo/getFundInfoCumulativeDate',
      data: {
        params: {
          fundCode: fundCode || '968195',
        }
      }
    })
    console.log(data, 'resData');
    
    // 如果 API 返回有效数据，使用返回的日期
    if (data && data.data && data.data[0] && data.data[0].DATA_TIME) {
      return moment(data.data[0].DATA_TIME).format('YYYY年MM月DD日')
    }
  } catch (error) {
    console.error('获取累积表现日期失败:', error);
  }
  // 降级方案：使用当前日期
  return moment(new Date()).format('YYYY年MM月DD日')
}